import { Button } from "antd";

type Props = {
  title: string;
  para?: string;
  status?: string;
  buttonColor?: string;
  closeModal: any;
  color: string;
  LocationId: any;
  invalidateQueries?: any;
  indexDelete?: number;
  requestDelete?: any;
  requestStatus?: any;
  request?: any;
};

const ConfirmModal = ({
  title,
  para,
  status,
  buttonColor,
  closeModal,
  color,
  invalidateQueries = "location",
  LocationId,
  requestDelete,
  requestStatus,
  request,
}: Props) => {
  const onFinish = (status: string | undefined) =>
    status === "delete"
      ? requestDelete(
          {
            ids: Array.isArray(LocationId) ? LocationId : [LocationId],
          },

          closeModal
        )
      : requestStatus({
          ids: Array.isArray(LocationId) ? LocationId : [LocationId],
          status,
        });

  return (
    <div className="flex flex-col items-center justify-center">
      <h2 className="text-lg font-semibold text-center text-gray-800">
        {title}
      </h2>
      <p className="mt-2 text-center text-gray-600">{para}</p>
      <div className="flex w-full gap-4 mt-6 ">
        <Button
          onClick={() => onFinish(status)}
          style={{ background: color }}
          type="primary"
          htmlType="submit"
          block
          className={`${buttonColor} `}
        >
          Confirm
        </Button>
        <Button onClick={closeModal} type="default" htmlType="button" block>
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default ConfirmModal;
